import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TimeService } from '../time.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  showLoader = false;
  orderDetails: any = {};
  dimension = false;
  paymentTerm ='';
  constructor(@Inject (MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<OrderDetailsComponent>,
              private timeService: TimeService) { }

  ngOnInit() {
    console.log(' >> ',this.parentData)
    this.initOrderDetails();
  }
  initOrderDetails() {
    this.orderDetails.order = this.parentData.order;
    this.orderDetails.allocations = this.parentData.allocations;
    this.orderDetails.allocatedTime = (this.parentData.allocations && this.parentData.allocations.length) ? this.timeService.toShortDateTime(this.parentData.allocations[0].created_at) : 'N/A';
    this.orderDetails.pickups = this.parentData.from;
    this.orderDetails.drops = this.parentData.to;
    this.orderDetails.shipper = this.parentData.shipper;
    this.orderDetails.materials = this.parentData.materials ;
    this.orderDetails.permits = this.parentData.permits;
    this.orderDetails.accessories = this.parentData.accessories ;
    this.orderDetails.comments = this.parentData.comments ? this.parentData.comments : '--';
    this.orderDetails.documents = this.parentData.docs;
    this.orderDetails.vehicle = this.parentData.vehicle.name;
    this.orderDetails.shipmentWeight = (this.parentData.weight_based && this.parentData.weight_based.length>0 ) ? this.parentData.weight_based.total : this.parentData.shipmentWeight;
    this.orderDetails.bidding = this.parentData.bidding;
    this.orderDetails.packages = this.parentData.packages;
    this.orderDetails.cbm = this.parentData.cbm;
    this.orderDetails.uom = this.parentData.uom;
    this.orderDetails.purchase_order = this.parentData.purchase_order;
    this.orderDetails.segmentation = this.parentData.segmentations  ? this.parentData.segmentations : '';
    this.orderDetails.allocation_type = this.parentData.allocation_type;
    this.orderDetails.projectCodes = this.parentData.project_codes;
    this.orderDetails.soNumber = this.parentData.soNumber;
    this.orderDetails.lcExpiryDate = this.parentData.lcExpiryDate;
    if(this.parentData.payment_term){
      let payment_term = this.parentData.payment_term;
      if(payment_term == '30D'){
        this.paymentTerm = '30 Days';
      }else if(payment_term == '45D'){
        this.paymentTerm = '45 Days';
      }else if(payment_term == 'AP'){
        this.paymentTerm = 'Advance Payment';
      }else if(payment_term == 'PAD'){
        this.paymentTerm = 'Payment After Delivery';
      }
    }
    if(this.orderDetails.materials && this.orderDetails.materials.length) {
      this.orderDetails.materials.forEach(element => {
        this.dimension = this.dimension || (element.others.l || element.others.b || element.others.h);
      });
    }
  }
  toShortDateTime(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }
  closeDialog() {
    this.dialog.close();
  }
}
